import type { MotionStyle } from 'motion/react';
import type { CSSProperties } from 'react';

type StyleVars = Record<
  `--${string}`,
  string | number | boolean | undefined | null
>;

/**
 * Type casting identity function. Maintains the autocompletion and type safety
 * of `CSSProperties`, while allowing the addition of CSS variables.
 *
 * @example
 * <div
 *   className="flex items-(--align) transition-opacity"
 *   style={styleVars({
 *     opacity: props.visible ? 1 : 0,
 *     '--align': props.align,
 *   })}
 * />
 */
export function styleVars(properties: CSSProperties & StyleVars) {
  return properties as CSSProperties;
}

/**
 * Type casting identity function.
 *
 * @see {@link styleVars}
 */
export function motionStyleVars(properties: MotionStyle & StyleVars) {
  return properties as MotionStyle;
}
